<!--发布通知  -->
<template>
  <div class="page-content">
    <div class="content">
      <p class="publish_time">发布时间</p>
      <div class="time-height">
        <div class="start_time">
          <i class="iconfont iconfont-color">&#xe608;</i>
          <div @click="open(1)">
            <p class="year_month_time" v-cloak>{{ startTime[0] }}</p>
            <p class="hours_time" v-cloak>{{ startTime[1] }}</p>
          </div>
        </div>
        <img src="@/assets/infoPublic/images/border.png" alt="" class="border_img" />
        <li class="end_time" @click="open(2)">
          <p class="year_month_time" v-cloak>{{ endTime[0] }}</p>
          <p class="hours_time" v-cloak>{{ endTime[1] }}</p>
        </li>
      </div>
    </div>
    <ul class="notice_body">
      <li class="notice_choose">
        <div @click="noticeTypeShow = true">
          <i class="iconfont iconfont-color">&#xe60f;</i>
          <span class="notice-title">通知类型</span>
          <span v-cloak class="noticeType">{{ noticeType }}</span>
        </div>
        <i class=" van-icon van-icon-arrow van-cell__right-icon"></i>

      </li>
      <li>
        <div style="display: flex;align-items: center;width:100%;">
          <i class="iconfont iconfont-color">&#xe607;</i>
          <span>通知名称</span>
          <input class="notice-name" type="text" placeholder="请输入通知名称" v-model="formValidateNoticeOK.noticeName" maxlength="16" />
        </div>
      </li>
      <li class="notice_choose" @click="noticeColorShow = true">
        <div>
          <i class="iconfont iconfont-color">&#xe60a;</i>
          <span class="notice-title">字体颜色</span>
          <span v-cloak class="noticeColor">{{ noticeColor }}</span>
        </div>
        <i class=" van-icon van-icon-arrow van-cell__right-icon"></i>
      </li>
      <li class="notice_publish_content">
        <div>
          <i class="iconfont iconfont-color">&#xe61a;</i>
          <span>发布内容</span>
        </div>
      </li>
      <van-field class="van-textarea" v-model="formValidateNoticeOK.noticeCont" type="textarea" maxlength="100" placeholder="请输入发布内容" />
    </ul>
    <div class="footer">
      <p class="publish_btn" @click="noticeOk">发布到指定班牌</p>
    </div>
    <van-popup v-model="showStart" position="bottom" :style="{ height: '40%'}">
      <van-datetime-picker @cancel='showStart=false' :min-date="minDate" @confirm='sureStartTime' v-model="startTimeOld" type="datetime" />
    </van-popup>
    <van-popup v-model="showEnd" position="bottom" :style="{ height: '40%'}">
      <van-datetime-picker @cancel='showEnd=false'  :min-date="minDate" @confirm='sureEndTime' v-model="endTimeOld" type="datetime" />
    </van-popup>
    <van-action-sheet v-model="noticeTypeShow" :actions="noticeTypeList" cancel-text="取消" @cancel="noticeTypeShow=false" @select="selectNoticeType" />
    <van-action-sheet v-model="noticeColorShow" :actions="noticeColorList" cancel-text="取消" @cancel="noticeColorShow=false" @select="selectNoticeColor" />
  </div>
</template>

<script>
import { Notify } from "vant"
export default {
  name: "Notice",
  data () {
    return {
      minDate:new Date(),
      showStart: false,
      showEnd: false,
      startTimeOld: "",
      endTimeOld: "",
      startTime: ["请选择发布开始时间", ""],
      endTime: ["请选择发布结束时间", ""],
      noticeTypeShow: false,
      noticeColorShow: false,
      noticeType: "请选择通知类型",
      noticeColor: "请选择字体颜色",
      noticeTypeList: [],
      noticeColorList: [],
      formValidateNoticeOK: {
        noticeType: "",
        noticeName: "",
        noticeColor: "",
        noticeCont: "",
        noticeDate: null
      },
      type:7,
    };
  },
  computed: {
    apipath () {
      return this.$store.state.apiPath || 'http://192.168.20.35:5071'
    }
  },
  created: function () {
    this.GetInformType()
    this.GetInformColor()
  },
  methods: {
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`;
      } else if (type === 'month') {
        return `${value}月`
      }
      return value;
    },
    open: function (value) {
      if (value === 1) {
        this.showStart = true
      } else {
        this.showEnd = true
      }
    },
    FormatDate: function (date) {
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      m = m < 10 ? "0" + m : m
      let d = date.getDate()
      d = d < 10 ? "0" + d : d
      let h = date.getHours()
      h = h < 10 ? "0" + h : h
      let minute = date.getMinutes()
      minute = minute < 10 ? "0" + minute : minute
      return y + "-" + m + "-" + d + " " + h + ":" + minute
    },

    changeFormat: function (timeType) {
      let timeSet = timeType[0].split("-")
      timeType[0] = `${timeSet[0]}年${timeSet[1]}月${timeSet[2]}日`
      return timeType
    },
    sureStartTime () {
      this.showStart = false
      let time = this.startTimeOld
    
      let start = this.FormatDate(time).split(" ")
      this.startTime = this.changeFormat(start)
    },
    sureEndTime () {
      this.showEnd = false
      let time = this.endTimeOld
      let end = this.FormatDate(time).split(" ")
      this.endTime = this.changeFormat(end)
    },
    // 发布到指定班牌
    noticeOk: function () {
      let _this = this
      // 时间格式转换
      let startT = 0
      let endT = 0
      if (this.endTimeOld) {
        let time = _this.endTimeOld
        time = this.FormatDate(time)
        endT = new Date(time.replace(/-/g, "/")).getTime()
      }
      if (this.startTimeOld) {
        let time = this.startTimeOld
        time = this.FormatDate(time)
        startT = new Date(time.replace(/-/g, "/")).getTime()
      }

      if (!this.startTimeOld) {
        Notify({ type: "danger", message: "请选择发布开始时间" })
        return
      } else if (!this.endTimeOld) {
        Notify({ type: "danger", message: "请选择发布结束时间" })
        return
      } else if (endT < startT) {
        Notify({ type: "danger", message: "发布开始时间不能晚于结束时间" })
        return
      } else if (!this.formValidateNoticeOK.InformTypeID > 0) {
        Notify({ type: "danger", message: "请选择通知类型" })
        return
      } else if (!this.formValidateNoticeOK.noticeName) {
        Notify({ type: "danger", message: "请输入通知名称" })
        return
      } else if (!this.formValidateNoticeOK.InformColorID > 0) {
        Notify({ type: "danger", message: "请选择字体颜色" })
        return
      } else if (!this.formValidateNoticeOK.noticeCont > 0) {
        Notify({ type: "danger", message: "请输入发布内容" })
        return
      }
      let obj = {
        InformTypeName: _this.noticeType, //通知类型
        InformColorName: _this.noticeColor,
        InformTypeID: _this.formValidateNoticeOK.InformTypeID,
        InformName: _this.formValidateNoticeOK.noticeName,
        InformColorID: _this.formValidateNoticeOK.InformColorID,
        InformContent: _this.formValidateNoticeOK.noticeCont,
        StartDate: this.FormatDate(_this.startTimeOld),
        EndDate: this.FormatDate(_this.endTimeOld),
        ClassTerminalID: []
      }
      // let classTerminal = []
      // xy.http.load( xy.subMenuWebUrl + "/View/ipInfoManage/Mobile/View/SelectClassCard/SelectClassCard.html", {
      //     targetID: "XyContentModuleReplace",
      //     loadParams: {
      //       type: 7,
      //       noticeData: obj,
      //       classTerminal: classTerminal
      //     }
      //   })
      // this.$router.push({path:'/home/SelectClassCard',query:{type:7,classTerminal: [], noticeData: obj,}})

      var classTerminal = [];
      this.$store.commit('infoPublic/setnoticeData', obj);
      this.$store.commit('infoPublic/settypePic', this.type);
      this.$store.commit('infoPublic/setclassTerminal', classTerminal);
      this.$router.push('/home/SelectClassCard');
      
    },

    // 获取通知类型下拉框
    GetInformType: function () {
      this.xy.loading()
      let that = this
      this.xyapi.get(`${this.apipath}/api/Resource/GetInformType`).then(res => {
        if (res.success) {
          res.data.data.forEach(function (item) {
            that.noticeTypeList.push({
              name: item.InformTypeName,
              id: item.InformTypeID,
            })
          })
        } else {
          Notify({ type: "error", message: res.msg })
        }
        this.xy.unloading()
      }).catch(err => {
        Notify({ type: "error", message: err.msg })
        this.xy.unloading()
      })
    },
    // 获取字体颜色下拉框
    GetInformColor: function () {
      this.xy.loading()
      let that = this
      this.xyapi.get(`${this.apipath}/api/Resource/GetInformColor`).then(res => {
        if (res.success) {
          res.data.data.forEach(function (item) {
            that.noticeColorList.push({
              name: item.InformColorName,
              id: item.InformColorID,
            })
          })
        } else {
          Notify({ type: "error", message: res.msg })
        }
        this.xy.unloading()
      })
    },
    selectNoticeType (item) {
      this.formValidateNoticeOK.InformTypeID = item.id
      this.noticeType = item.name
      this.noticeTypeShow = false
    },
    selectNoticeColor (item) {
      this.formValidateNoticeOK.InformColorID = item.id
      this.noticeColor = item.name
      this.noticeColorShow = false
    },
  }
}
</script>
<style lang="less" scoped>
.page-content {
  .van-action-sheet /deep/ {
    max-height: 50% !important;
  }
  .iconfont-color {
    color: #cfcccf;
  }
  .content {
    background-color: #fff;
    .publish_time {
      width: 100%;
      padding: 15px 20px;
      font-size:26px;
      font-weight: 600;
      color: rgba(25, 22, 25, 1);
      border-bottom: 1px solid rgba(240, 241, 245, 1);
    }
    .time-height {
      height: 150px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
      .start_time {
        display: flex;
        align-items: center;
        div{
          margin-left: 20px;
        }
      }
      .end_time {
        width: 40%;
        margin-left: -10%;
      }
      .year_month_time {
        font-size: 24px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }

      .hours_time {
        font-size: 26px;
        font-weight: 400;
        color: rgba(25, 22, 25, 1);
      }
      .border_img {
        margin-right: 20px;
        height: 100%;
      }
    }
  }
  .notice_body .noticeType,
  input,
  .noticeColor {
    display: inline-block;
    font-size: 28px;
    font-weight: 300;
    color: rgba(153, 153, 153, 1);
    padding: 0 20px;
    border: none;
    font-family: Microsoft YaHei;
  }

  .noticeType,
  .noticeColor {
    width: 60%;
  }
  .notice_body {
    margin-top: 20px;
    padding-bottom: 50px;
    background-color: #fff;
    li {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border-bottom: 1px solid rgba(240, 241, 245, 1);
      padding: 25px 20px;
    }
    .notice_choose {
      justify-content: space-between !important;
      align-items: center;
      div {
        width: 100%;
        display: flex;
        align-items: center;
      }
    }
    .notice_publish_content {
      border-bottom: none !important;
    }
    span {
      font-size: 28px;
      font-weight: 300;
      color: rgba(102, 102, 102, 1);
      display: inline-block;
      padding: 20px;
    }
    .notice-name {
      flex-grow: 1;
      margin-left: 20px;
      padding-left: 0;
    }

    .van-textarea {
      border: 1px solid rgba(240, 241, 245, 1) !important;
      padding: 20px !important;
      width: 94%;
      margin: 0 auto;
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 20px 0;
    background: #fff;
    .publish_btn {
      padding: 15px 50px;
      font-size: 30px;
      font-weight: normal;
      color: rgba(255, 255, 255, 1);
      background: rgba(65, 150, 255, 1);
      border-radius: 38px;
    }
  }
}
</style>
